/* ============================================================
   [MKR] — EDITORIAL BRUTALIST JS
   - Scroll Reveal
   - Category Filter (Collection Page)
   - Email Capture Form Handler
   - Ticker Animation
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ===== SCROLL REVEAL =====
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(el => observer.observe(el));
  }

  // ===== CATEGORY FILTER =====
  const filterBtns = document.querySelectorAll('[data-filter-btn]');
  const productCards = document.querySelectorAll('[data-product-type]');

  if (filterBtns.length > 0) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filterBtn;

        // Update active state
        filterBtns.forEach(b => {
          b.style.background = 'transparent';
          b.style.color = '#121212';
        });
        btn.style.background = '#121212';
        btn.style.color = '#F5F0E8';

        // Filter products
        productCards.forEach(card => {
          const type = card.dataset.productType || '';
          if (filter === 'all' || type.toLowerCase().includes(filter.toLowerCase())) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });

        // Update count
        const countEl = document.querySelector('[data-filter-count]');
        if (countEl) {
          const visible = [...productCards].filter(c => c.style.display !== 'none').length;
          countEl.textContent = visible;
        }
      });
    });
  }

  // ===== EMAIL CAPTURE FORM =====
  const emailForms = document.querySelectorAll('[data-brutalist-email-form]');
  emailForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button[type="submit"]');
      const msg = form.querySelector('[data-form-message]');
      if (!input || !input.value) return;

      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'WIRD GESENDET...'; btn.disabled = true; }

      try {
        // Shopify Customer Subscribe (works with Klaviyo if connected)
        const res = await fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            form_type: 'customer',
            utf8: '✓',
            'contact[email]': input.value,
            'contact[tags]': 'newsletter,mkr-launch',
          })
        });

        if (msg) {
          msg.textContent = 'EINGETRAGEN/ DU BIST DABEI.';
          msg.style.color = '#CC2200';
        }
        input.value = '';
      } catch (err) {
        if (msg) { msg.textContent = 'FEHLER/ VERSUCH ES NOCHMAL.'; }
      } finally {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      }
    });
  });

  // ===== TICKER ANIMATION =====
  const tickers = document.querySelectorAll('[data-ticker]');
  tickers.forEach(ticker => {
    const inner = ticker.querySelector('[data-ticker-inner]');
    if (!inner) return;
    const clone = inner.cloneNode(true);
    ticker.appendChild(clone);
  });

  // ===== PRODUCT IMAGE HOVER =====
  document.querySelectorAll('.card__media').forEach(media => {
    const imgs = media.querySelectorAll('img');
    if (imgs.length >= 2) {
      media.addEventListener('mouseenter', () => { imgs[0].style.opacity = '0'; imgs[1].style.opacity = '1'; });
      media.addEventListener('mouseleave', () => { imgs[0].style.opacity = '1'; imgs[1].style.opacity = '0'; });
      imgs[1].style.position = 'absolute';
      imgs[1].style.inset = '0';
      imgs[1].style.opacity = '0';
      imgs[1].style.transition = 'opacity 0.2s ease';
      imgs[0].style.transition = 'opacity 0.2s ease';
    }
  });

});
